import React, { useEffect } from 'react';
import { D as DataListItems } from './DataListItems-DtWRKCB4.js';
import { u as useDataListContext } from './DataListContext-CyU4jeBU.js';
import { u as useActiveLayout } from './useActiveLayout-Cit0_Js3.js';

function DataListLayout({ children, size = "xs", }) {
    const { registerLayout, loadingState } = useDataListContext();
    const { activeBreakpoint } = useActiveLayout();
    useEffect(() => {
        registerLayout(size, children);
    }, [size, children]);
    const shouldRenderList = size === activeBreakpoint;
    if (loadingState !== "initial" && shouldRenderList) {
        return React.createElement(DataListItems, { size: size });
    }
    return null;
}

export { DataListLayout as D };
